import React from "react";
import FormFieldComponent from "../FormFieldComponent";
import {tryToParse} from "../../../utils/arrayObjectHelper";

const componentClass = "collectionItem";

const CollectionItem = ({ onChange, useStringify, value, fields }) => {
    const values = value && useStringify ? tryToParse(value, {}) : (value || {});

    const onUpdateValues = (nuValues) => {
        const valuesToSave = useStringify ? JSON.stringify(nuValues) : nuValues;
        onChange(valuesToSave);
    };

    return <div className={componentClass}>
        { fields.map((field, i) => {
            const fieldKey = field?.key || field?.id;
            const onFieldChange = nuValue => {
                const nuValues = {...values};
                nuValues[fieldKey] = nuValue;
                onUpdateValues(nuValues);
            };
            return <FormFieldComponent
                fieldConfig={field}
                onFieldChange={onFieldChange}
                value={values[fieldKey]}
                data={values}
                className={`${componentClass}__field`}
                key={i}
            />
        })}
    </div>;
}

export default CollectionItem;
